import moment from "moment"

let initialState = {
    truck_list_loader: true,
    truck_list: [],
    truck_stoppagination: false,
    truck_page: 1,
    truck_list_error: null,
    truck_search_keyword: '',

    vehicle_modal: false,
    vehicle_img_modal: false,
    selected_truck: {},

    truck_maintanace_list: [],
    truck_maintanace_stoppagination: false,
    truck_maintanace_error: null,
    truck_maintanace_loader: false,
    truck_maintanance_page: 1,

    maintanace_search_qry: '',
    maintanance_filterKey: 'all',

    selected_truck_maintanance: {},

    all_truck_list: [],

    truck_fuel_list: [],
    truck_fuel_error: null,
    truck_fuel_loader: false,
    truck_fuel_stoppagination: false,
    truck_fuel_page: 1,

    fuel_search_qry: '',
    fuel_filterKey: 'all',

    selected_truck_fuel: {},


    truck_fleet_list: [],
    selected_truck_fleet: {},
    truck_fleet_page: 1,

    filtered_truck_list: [],
    filterKey: 'all',

    selected_pre_inspect: {},
    edit_pre_inspObj: {},
    vehicle_id: '',

    truck_preInsp_list: [],
    pre_insp_page: 1,
    pre_insp_loader: false,
    pre_insp_error: null,
    pre_insp_stoppagination: false,

    pre_insp_search_qry: '',
    pre_insp_filterKey: 'all',

    isLoading: false

}

const truck = (state = initialState, actions) => {
    switch (actions.type) {
        case "TRUCK_LIST_FETCHING":
            if (actions && actions.keyword) {
                return {
                    ...state,
                    truck_list_loader: true,
                    truck_list_error: null,
                    truck_list: actions.page === 1 ? [] : state.truck_list,
                    truck_search_keyword: actions.keyword,
                    truck_page: actions.page
                }
            } else {
                return {
                    ...state,
                    truck_list_loader: true,
                    truck_list_error: null,
                    truck_search_keyword: '',
                    truck_list: actions.page ? (actions.page === 1 ? [] : state.truck_list) : state.truck_list
                }
            }

        case "TRUCK_LIST":
            // if ((actions.page === 1 && state.truck_list.length === 0) || actions.page !== state.truck_page) {
            return {
                ...state,
                truck_list: actions.page === 1 ? actions.trucks : state.truck_list.concat(actions.trucks),
                truck_page: actions.page,
                truck_stoppagination: actions.trucks.length === 15 ? false : true,
                truck_list_loader: false,
                truck_list_error: null
            }
        // } else {
        //     return {
        //         ...state,
        //         truck_list_loader: false
        //     }
        // }
        case "TRUCK_LIST_ERROR":
            return {
                ...state,
                truck_list_loader: actions.error.text === 'Unknown error' ? state.truck_list_loader : false,
                truck_list_error: actions.error
            }

        case "TRUCK_FILTERED_MNTN_LIST":
            return {
                ...state,
                truck_maintanace_list: actions.page === 1 ? actions.trucks : state.truck_maintanace_list.concat(actions.trucks),
                filterKey: actions.filterKey? actions.filterKey: state.filterKey,
                maintanace_search_qry: actions.keyword? actions.keyword: state.maintanace_search_qry,
                truck_maintanace_loader: false,
                truck_maintanace_error: null,
                isLoading: false,
                truck_maintanance_page: actions.page,
                truck_maintanace_stoppagination: actions.trucks.length === 15 ? false : true
            }

        case "TRUCK_FILTERED_FUEL_LIST":
            return {
                ...state,
                truck_fuel_list:actions.page === 1 ? actions.trucks : state.truck_fuel_list.concat(actions.trucks),
                filterKey: actions.filterKey? actions.filterKey: state.filterKey,
                fuel_search_qry: actions.keyword? actions.keyword: state.fuel_search_qry,
                truck_fuel_loader: false,
                truck_fuel_error: null,
                isLoading: false,
                truck_fuel_page: actions.page,
                truck_fuel_stoppagination: actions.trucks.length === 15 ? false : true
            }


        case "TRUCK_REFRESH_FILTER":
            return {
                ...state,
                filterKey: 'all',
                filtered_truck_list: [],
                truck_preInsp_list: [],
                truck_fuel_list: [],
                pre_insp_loader: true,
            }

        case "TRUCK_MAINTANACE_LIST_FETCHING":
            if (actions && actions.keyword) {
                return {
                    ...state,
                    truck_maintanace_loader: true,
                    truck_maintanace_error: null,
                    maintanace_search_qry: actions.keyword,
                    truck_maintanace_list: actions.page === 1 ? [] : state.truck_maintanace_list,
                    truck_maintanance_page: actions.page,
                }
            } else if (actions && actions.filter) {
                return {
                    ...state,
                    truck_maintanace_loader: true,
                    truck_maintanace_error: null,
                    truck_maintanace_list: actions.page === 1 ? [] : state.truck_maintanace_list,
                    filtered_truck_list: [],
                    maintanace_search_qry: '',
                    filterKey: actions.filter,
                    truck_maintanance_page: actions.page,
                }
            } else {
                return {
                    ...state,
                    truck_maintanace_loader: true,
                    truck_maintanace_error: null,
                    maintanace_search_qry: '',
                    truck_maintanace_list: actions.page ? (actions.page === 1 ? [] : state.truck_maintanace_list) : state.truck_maintanace_list
                }
            }

        case "TRUCK_MAINTANACE_LIST":
            // if ((actions.page === 1 && state.truck_maintanace_list.length === 0) || actions.page !== state.truck_maintanance_page) {
            let tempListMNTC = state.truck_maintanace_list
            if(actions.page===1)
                tempListMNTC = actions.maintanace
            else if(state.truck_maintanance_page === actions.page){
                tempListMNTC.splice((15*(parseInt(actions.page)-1)), tempListMNTC.length-(15*(parseInt(actions.page)-1)), ...actions.maintanace)
            }
            else 
                tempListMNTC = state.truck_maintanace_list.concat(actions.maintanace)

            return {
                ...state,
                truck_maintanace_list: tempListMNTC,
                truck_maintanance_page: actions.page,
                truck_maintanace_stoppagination: actions.maintanace.length === 15 ? false : true,
                truck_maintanace_loader: false,
                truck_maintanace_error: null
            }
        // } else {
        //     return {
        //         ...state,
        //         truck_maintanace_loader: false
        //     }
        // }
        case "TRUCK_MAINTANACE_LIST_FAILED":
            return {
                ...state,
                truck_maintanace_error: actions.error,
                truck_maintanace_loader: actions.error.text === 'Unknown error' ? state.truck_maintanace_loader : false,
            }
        case "ALL_TRUCK_LIST":
            return {
                ...state,
                all_truck_list: actions.trucks,
                isLoading: false
            }

        case "VEHCILE_MODAL":
            return {
                ...state,
                vehicle_modal: actions.modal
            }

        case "VEHCILE_IMG_MODAL":
            return {
                ...state,
                vehicle_img_modal: actions.modal
            }

        case "SELECT_TRUCK":
            return {
                ...state,
                selected_truck: actions.truck
            }

        case "SELECT_TRUCK_MAINTANACE":
            return {
                ...state,
                selected_truck_maintanance: actions.maintanace
            }

        case "TRUCK_FUEL_LIST_FETCHING":
            if (actions && actions.keyword) {
                return {
                    ...state,
                    truck_fuel_loader: true,
                    truck_fuel_error: null,
                    fuel_search_qry: actions.keyword,
                    truck_fuel_list: actions.page === 1 ? [] : state.truck_fuel_list,
                    truck_fuel_page: actions.page,
                }
            } else if (actions && actions.filter) {
                return {
                    ...state,
                    truck_fuel_loader: true,
                    truck_fuel_error: null,
                    truck_fuel_list: actions.page === 1 ? [] : state.truck_fuel_list,
                    filtered_truck_list: [],
                    fuel_search_qry: '',
                    filterKey: actions.filter,
                    truck_fuel_page: actions.page,
                }
            } else {
                return {
                    ...state,
                    truck_fuel_loader: true,
                    truck_fuel_error: null,
                    fuel_search_qry: '',
                    truck_fuel_list: actions.page ? (actions.page === 1 ? [] : state.truck_fuel_list) : state.truck_fuel_list
                }
            }
        case "TRUCK_FUEL_LIST":
            // if ((actions.page === 1 && state.truck_fuel_list.length === 0) || actions.page !== state.truck_fuel_page) {
            return {
                ...state,
                truck_fuel_list: actions.page === 1 ? actions.fuel : state.truck_fuel_list.concat(actions.fuel),
                truck_fuel_page: actions.page,
                truck_fuel_stoppagination: actions.fuel.length === 15 ? false : true,
                truck_fuel_loader: false,
                truck_fuel_error: null
            }
        // } else {
        //     return {
        //         ...state,
        //         truck_fuel_loader: false
        //     }
        // }
        case "TRUCK_FUEL_LIST_ERROR":
            return {
                ...state,
                truck_fuel_loader: actions.error.text === 'Unknown error' ? state.truck_fuel_loader : false,
                truck_fuel_error: actions.error
            }
        case "SELECT_TRUCK_FUEL":
            return {
                ...state,
                selected_truck_fuel: actions.fuel
            }


        case "TRUCK_FLEET_LIST":
            return {
                ...state,
                truck_fleet_list: actions.fleet,
                truck_fleet_page: actions.page,
                vehicle_id: actions.vehicle,
                isLoading: false
            }

        case "SET_FLEET_VEHICLE_ID":
            return {
                ...state,
                vehicle_id: actions.vehicle,
                isLoading: false
            }

        case "CLEAR_TRUCK_FLEET_LIST":
            return {
                ...state,
                truck_fleet_list: []
            }

        case "SELECT_TRUCK_FLEET":
            return {
                ...state,
                selected_truck_fleet: actions.fleet
            }

        case "SELECTED_TRUCK_PRE-INSPECT":
            return {
                ...state,
                selected_pre_inspect: actions.selObj,
                edit_pre_inspObj : {
                    Vehicle                 : actions.selObj.vehicle
                    , Date_time             : actions.selObj.date_time
                    , DriverName            : actions.selObj.driver_name
                    , DriverNameStr         : actions.selObj.name
                    , Odometer              : actions.selObj.odometer       
                    , DriverSignature       : actions.selObj.odometdriver_signature       
                    , HourMeterStart        : actions.selObj.hour_meter_start       
                
                    , FitForWork            : actions.selObj.fit_for_work       
                    , ValidDrivingLicense   : actions.selObj.Valid_driving_license       
                    , AppropriatePPE        : actions.selObj.appropriate_ppe       
                
                    , EngineOilLevel        : actions.selObj.engine_oil_level       
                    , WarningSystem         : actions.selObj.warning_system       
                    , Steering              : actions.selObj.steering       
                    , SafetyEmrgStop        : actions.selObj.safety_emerg_stop       
                    , HandBreakAlram        : actions.selObj.handbreak_alarm       
                    , PTOVacPump            : actions.selObj.pto_vacpump       
                
                    , Horn                  : actions.selObj.horn
                    , RevAlarmCamera        : actions.selObj.rev_alarm_camera
                    , LightsHead            : actions.selObj.lights_head
                    , LightsTail            : actions.selObj.lights_tail
                    , LightsBeacon          : actions.selObj.light_beacons
                    , HazardLight           : actions.selObj.hazard_light
                    , HouseKeeping          : actions.selObj.house_keeping
                
                    , RimsWheels            : actions.selObj.rims_wheelnut
                    , Coolant               : actions.selObj.coolant
                    , Wheels                : actions.selObj.wheels
                    , MirrorWindows         : actions.selObj.mirror_windowscreen
                    , StructureBody         : actions.selObj.structure_bodywork
                    , Wipers                : actions.selObj.wipers
                
                    , FuelLevelPump         : actions.selObj.fuel_levelpump
                    , FuelLevelTruck        : actions.selObj.fuel_leveltruck
                    , SeatSeatbelt          : actions.selObj.seat_seatbelt
                    , ParkBreakTrailer      : actions.selObj.parkbrake_trailer
                    , FootBrake             : actions.selObj.foot_brake
                    , Electrical            : actions.selObj.electrical
                    , PinRetainer           : actions.selObj.pin_retainers
                
                    , Hoses                 : actions.selObj.hoses
                    , Fittings              : actions.selObj.fittings
                    , FirstAidKit           : actions.selObj.first_aid_kit
                    , PPE                   : actions.selObj.ppe
                    , FireExtingusre        : actions.selObj.fire_extinguisher
                    , FireExtingusreDate    : moment(actions.selObj.fire_extinguisher_date).isValid() ?
                         moment(actions.selObj.fire_extinguisher_date).format('YYYY-MM-DD') : actions.selObj.fire_extinguisher_date
                    , GardenHose            : actions.selObj.garden_hose
                    , GaticLiters           : actions.selObj.gatic_lifters
                    , BucketRag             : actions.selObj.bucket_rags
                    , SpillKit              : actions.selObj.spill_kit
                
                    , FaultReportz          : actions.selObj.reported_fault_string
                
                    , ReadyToOperate        : actions.selObj.safe_ready_to_operate
                    , ReportedFaults        : actions.selObj.reported_faults
                    , ReviewdForm           : actions.selObj.reviewed_form
                
                    , Corrected             : actions.selObj.corrected
                    , ScheduledForRepair    : actions.selObj.scheduled_for_repair
                    , NoAction              : actions.selObj.no_action
                    , DoNotAffectSafeOperation    : actions.selObj.do_not_affect_safe_operation
                
                }
            }

        case "TRUCK_FILTERED_LIST":
            return {
                ...state,
                filtered_truck_list: actions.trucks,
                truck_preInsp_list: actions.page === 1 ? actions.trucks : state.truck_preInsp_list.concat(actions.trucks),
                pre_insp_loader: false,
                filterKey: actions.filterKey? actions.filterKey: state.filterKey,
                pre_insp_search_qry: actions.keyword? actions.keyword: state.pre_insp_search_qry,
                pre_insp_error: null,
                pre_insp_page: actions.page,
                pre_insp_stoppagination: actions.trucks.length === 15 ? false : true
            }
        case "FETCHING_PREINSP_LIST":
            if (actions && actions.keyword) {
                return {
                    ...state,
                    pre_insp_loader: true,
                    pre_insp_error: null,
                    pre_insp_search_qry: actions.keyword,
                    truck_preInsp_list: actions.page === 1 ? [] : state.truck_preInsp_list,
                    pre_insp_page: actions.page,
                }
            } else if (actions && actions.filter) {
                return {
                    ...state,
                    pre_insp_loader: true,
                    pre_insp_error: null,
                    truck_preInsp_list: actions.page ? (actions.page === 1 ? [] : state.truck_preInsp_list) : state.truck_preInsp_list,
                    filtered_truck_list: [],
                    pre_insp_search_qry: '',
                    filterKey: actions.filter,
                    pre_insp_page: actions.page,
                }
            } else {
                return {
                    ...state,
                    pre_insp_loader: true,
                    pre_insp_error: null,
                    pre_insp_search_qry: '',
                    truck_preInsp_list: actions.page ? (actions.page === 1 ? [] : state.truck_preInsp_list) : state.truck_preInsp_list
                }
            }
        case "PREINSP_LIST_SUCCESS":
            // if ((actions.page === 1 && state.truck_preInsp_list.length === 0) || actions.page !== state.pre_insp_page) {
            return {
                ...state,
                truck_preInsp_list: actions.page === 1 ? actions.trucks : state.truck_preInsp_list.concat(actions.trucks),
                pre_insp_page: actions.page,
                pre_insp_stoppagination: actions.trucks.length === 15 ? false : true,
                pre_insp_loader: false,
                pre_insp_error: null
            }
        // } else {
        //     return {
        //         ...state,
        //         pre_insp_loader: false
        //     }
        // }
        case "PREINSP_LIST_ERROR":
            return {
                ...state,
                pre_insp_loader: actions.error.text === 'Unknown error' ? state.pre_insp_loader : false,
                pre_insp_error: actions.error

            }

        case "TRUCK_EDIT_LIST":
            let oldData = state.truck_list
            let oldDataIdx = oldData.findIndex(el => el.id === actions.id)
            oldData[oldDataIdx] = actions.content;
            console.log('EDITTED->Reducer',oldData,oldDataIdx)
            return {
                ...state,
                truck_list: oldData
            }

        default:
            return state

    }
}

export default truck